<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    app
    width="300"
    :mini-variant="miniVariant"
    mini-variant-width="0"
    @update:mini-variant="mini = $event"
  >
    <v-dialog
      v-model="dialog"
      width="500px"
    >
      <v-card>
        <v-card-title>
          {{ formTitle }}
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Company name"
                />
                <v-col cols="12">
                  <v-file-input
                    v-model="editedItem.image"
                    label="Image"
                  />
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="success"
            text
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="wifiDialog"
      width="600px"
    >
      <v-card>
        <v-card-title> WiFi Config </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="wifiItem.essid"
                  label="SSID"
                  outlined
                />
                <v-autocomplete
                  v-model="wifiItem.encryption"
                  :items="wifiEncryptions"
                  item-text="text"
                  item-value="value"
                  label="Encryption"
                  outlined
                />
                <v-text-field
                  v-model="wifiItem.password"
                  label="Key"
                  outlined
                />
              </v-col>
              <v-col
                class="align"
                cols="6"
              >
                <q-r-code
                  v-if="wifiItem.essid"
                  :value="`WIFI:S:${wifiItem.essid};T:${wifiItem.encryption};P:${wifiItem.password};;`"
                  :size="225"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="closeWifi"
          >
            Cancel
          </v-btn>
          <v-btn
            color="success"
            text
            @click="saveWifi"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="generateQRDialog"
      width="750px"
    >
      <v-card>
        <v-card-title> Generate-QR </v-card-title>
        <v-card-text>
          <v-btn
            color="primary"
            class="my-2"
            @click="totalQrs.push('QR')"
          >
            New
          </v-btn>
          <v-row>
            <v-col
              v-for="(qr, index) in totalQrs"
              :key="index"
              class="align"
              cols="4"
            >
              <v-text-field
                v-model="qrGenerate['Qr' + index]"
                label="QR"
                outlined
              />
              <q-r-code
                v-if="qrGenerate['Qr' + index]"
                :value="qrGenerate['Qr' + index]"
                :size="100"
              />
              {{ qrGenerate["Qr" + index] }}
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="generateQRDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <third-party-wifi-config-dialog
      v-model="wifiImageDialog"
      :company-id="getCompanyId"
    />
    <v-dialog
      v-model="dialogDelete"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <device-config-dialog
      :dialog="deviceConfigDialog"
      :company-id="currentObject.id"
      @close="deviceConfigDialog = false"
    />
    <device-files-dialog
      :dialog="deviceFilesDialog"
      @close="deviceFilesDialog = false"
    />
    <company-licensee-dialog
      v-model="companyLicenseeDialog"
      :company="currentObject"
      @company="onUpdateCompany"
    />
    <company-provisioning-qr-dialog
      v-model="provisioningQrDialog"
      :company="currentObject"
    />
    <v-dialog
      v-model="companyMetaDialog"
      max-width="640px"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h6 d-block">
          <div>Company Additional Info</div>
          <div
            v-if="currentObject && currentObject.name"
            class="text-subtitle-2 grey--text text--darken-1 mt-1"
          >
            {{ currentObject.name }}
          </div>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="companyMetaError"
            dense
            text
            type="error"
            class="mb-3"
          >
            {{ companyMetaError }}
          </v-alert>
          <div class="text-caption grey--text text--darken-1 mb-4">
            Store any label and value pairs for this company. Add as many as you need or remove the ones you don't.
          </div>

          <div
            v-for="(row, index) in companyMetaRows"
            :key="index"
            class="company-meta-row"
          >
            <v-text-field
              v-model.trim="row.label"
              outlined
              dense
              hide-details
              label="Label"
              placeholder="e.g. Network Code"
              :disabled="companyMetaSaving"
              class="company-meta-row__label"
            />
            <v-text-field
              v-model="row.value"
              outlined
              dense
              hide-details
              label="Value"
              :placeholder="row.placeholder"
              :disabled="companyMetaSaving"
              class="company-meta-row__value"
            />
            <v-btn
              icon
              small
              class="company-meta-row__remove"
              :disabled="companyMetaSaving"
              title="Remove field"
              @click="removeCompanyMetaRow(index)"
            >
              <v-icon color="error">
                mdi-close-circle-outline
              </v-icon>
            </v-btn>
          </div>

          <v-alert
            v-if="!companyMetaRows.length"
            dense
            text
            type="info"
            class="mb-0"
          >
            No fields yet. Use "Add field" to create one.
          </v-alert>

          <v-btn
            text
            color="primary"
            class="mt-2 px-2"
            :disabled="companyMetaSaving"
            @click="addCompanyMetaRow"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Add field
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="companyMetaSaving"
            @click="companyMetaDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="success"
            text
            :loading="companyMetaSaving"
            @click="saveCompanyMetaEdit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-treeview
      v-if="companies && companies.length"
      ref="treeview"
      :items="companies"
      :load-children="fetchChildren"
      item-key="id"
      color="warning"
      open-on-click
      dense
      transition
      @update:open="onExpand"
    >
      <template v-slot:prepend="{ item, open }">
        <img
          v-if="item.image"
          :src="getBaseUrl + item.image"
          class="mt-2"
          style="width:60px; height:40px; object-fit: contain; background: #fff; border-radius:10px;padding:5px"
        >
        <v-icon
          v-else-if="!item.image && !item.file"
          color="secondary"
          class="my-2"
          style="width:60px; height:40px; object-fit: contain; background: #fff; border-radius:10px;padding:3px"
        >
          {{ open ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
        <v-icon
          v-else
          class="my-2"
        >
          {{ files[item.file] }}
        </v-icon>
      </template>
      <template v-slot:label="{ item, open }">
        <draggable
          class="list-group"
          tag="div"
          :list="[item.id]"
          group="devices"
          style="margin-left: 5px;"
          @change="dragEvent($event, item.id)"
        >
          <div @click="onClick(item)">
            {{ item.name }}
          </div>
        </draggable>
      </template>
    </v-treeview>
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in visibleMenus"
          :key="index"
        >
          <v-list-item-title @click="menuHandler(item.title)">
            <v-edit-dialog v-if="item.title.includes('Enroll-QR')">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <template v-slot:input>
                <div class="pa-2 text-center">
                  <q-r-code
                    :value="encryptedCompanyCode"
                    :size="150"
                  />
                  {{ encryptedCompanyCode }}
                </div>
              </template>
            </v-edit-dialog>
            <div v-else>
              {{ item.title }}
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-navigation-drawer>
</template>

<script>
  import { sync, get } from 'vuex-pathify'
  import draggable from 'vuedraggable'
  import QRCode from '../../views/components/QRCode.vue'
  import DeviceConfigDialog from '../../views/components/DeviceConfigDialog.vue'
  import DeviceFilesDialog from '../../views/components/DeviceFilesDialog.vue'
  import ThirdPartyWifiConfigDialog from '../../views/components/ThirdPartyWifiConfigDialog.vue'
  import CompanyLicenseeDialog from '../../views/components/CompanyLicenseeDialog.vue'
  import CompanyProvisioningQrDialog from '../../views/components/CompanyProvisioningQrDialog.vue'
  import { encryptCompanyCode } from '@/utils/companyCodeCipher'
  import store from '@/store'

  export default {
    name: 'DefaultDrawer',
    components: {
      draggable,
      QRCode,
      DeviceConfigDialog,
      DeviceFilesDialog,
      ThirdPartyWifiConfigDialog,
      CompanyLicenseeDialog,
      CompanyProvisioningQrDialog,
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      wifiDialog: false,
      wifiImageDialog: false,
      deviceConfigDialog: false,
      deviceFilesDialog: false,
      generateQRDialog: false,
      companyLicenseeDialog: false,
      provisioningQrDialog: false,
      companyMetaDialog: false,
      companyMetaRows: [],
      companyMetaSaving: false,
      companyMetaError: '',
      // The address isn't rewritten until the company for a /<slug>/devices URL is resolved.
      companySlugRouteReady: false,
      qrGenerate: {},
      totalQrs: ['QR'],
      showMenu: false,
      x: 0,
      y: 0,
      suppressUntil: 0,
      pressTimer: null,
      currentObject: {},
      menus: [
        { title: 'Licensee' },
        { title: 'WiFi-QR' },
        { title: '3rd Party-QR' },
        { title: 'Generate-QR' },
        { title: 'Provisioning-QR' },
        { title: 'Scripts' },
        { title: 'Additional Info' },
        { title: 'Rename' },
        { title: 'Add' },
        { title: 'Delete' },
      ],
      items: [],
      editedIndex: -1,
      wifiEditedIndex: -1,
      wifiItem: {
        essid: '',
        encryption: '',
        password: '',
        companyId: '',
      },
      defaultWifi: {
        essid: '',
        encryption: '',
        password: '',
        companyId: '',
      },
      editedItem: {
        name: '',
        image: null,
      },
      defaultItem: {
        name: '',
        image: null,
      },
      wifiEncryptions: [{ text: 'WPA/WPA2', value: 'WPA' }],
      initialClick: false,
    }),
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      wifiDialog (val) {
        val || this.closeWifi()
      },
      wifiImageDialog (val) {
        val || this.closeWifiImage()
      },
      selectedCompanyId (val) {
        this.rememberSelectedCompanyId(val)
        this.syncCompanySlugRoute()
      },
      '$route.name' () {
        this.syncCompanySlugRoute()
      },
    },

    async created () {
      this.$signalHub.$on('open-company-menu', this.onOpenCompanyMenu)
      this.$signalHub.$on('open-company-provisioning-qr', this.openSelectedCompanyProvisioningQr)

      try {
        const companies = await store.dispatch('company/loadCompanies', 0)

        // Opening /<slug>/devices selects the company with that slug.
        const slugCompany = await this.findCompanyByRouteSlug()

        if (slugCompany) {
          this.currentObject = slugCompany
          store.dispatch('company/selectCompany', slugCompany.id)
        } else if (!this.selectedCompanyId && companies.length > 0) {
          if (this.$route.params.slug) {
            console.warn(`No company found with slug "${this.$route.params.slug}"; showing the first company.`)
          }
          this.currentObject = companies[0]
          store.dispatch('company/selectCompany', companies[0].id)
        }
      } catch (error) {
        this.showCompanyLoadError(error)
      } finally {
        this.companySlugRouteReady = true
        this.syncCompanySlugRoute()
      }
    },
    mounted () {
      document.addEventListener('click', () => { this.initialClick = true }, { once: true })
    },
    beforeDestroy () {
      this.$signalHub.$off('open-company-menu', this.onOpenCompanyMenu)
      this.$signalHub.$off('open-company-provisioning-qr', this.openSelectedCompanyProvisioningQr)
    },
    computed: {
      ...sync('app', ['drawer', 'drawerImage', 'mini']),
      // Collapse-to-mini is a desktop affordance; on mobile the drawer is a
      // full-width temporary overlay toggled by the hamburger (v-model="drawer").
      miniVariant () {
        return this.$vuetify.breakpoint.mobile ? false : this.mini
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      getBaseUrl () {
        return this.$http.defaults.baseURL.replace('api/', 'Resources/')
      },
      getCompanyId () {
        return this.currentObject ? this.currentObject.id : 0
      },
      getCompanyCode () {
        return this.currentObject ? this.currentObject.code : ''
      },
      encryptedCompanyCode () {
        return encryptCompanyCode(this.getCompanyCode)
      },
      ...get('company', ['selectedCompanyId', 'selectedCompanyName']),
      companies () {
        return store.getters['company/getBaseCompanies'] || []
      },
      isSuperUser () {
        return this.$store.getters['authUser/isSuperUser']
      },
      visibleMenus () {
        if (this.isSuperUser) {
          return this.menus
        }

        const superUserOnlyMenuTitles = new Set(['Licensee', 'Add', 'Delete'])
        return this.menus.filter(item => !superUserOnlyMenuTitles.has(item.title))
      },
    },

    methods: {
      dragEvent (evt, companyId) {
        if (evt.hasOwnProperty('added')) {
          this.$http
            .patch('Company/UpdateDeviceCompany', null, {
              params: { DeviceId: evt.added.element, CompanyId: companyId },
            })
            .then((response) => {
              if (response.data.success) {
                this.$toast.success(response.data.message, 'Success', {
                  position: 'topRight',
                })
              } else {
                this.$toast.error(response.data.message, 'Error', {
                  position: 'topRight',
                })
              }
            })
        }
      },
      onClick (item, e) {
        // A long-press opens the context menu; swallow the click(s) it also
        // fires so we don't select + close the drawer underneath the menu.
        if (Date.now() < this.suppressUntil) {
          return
        }

        this.currentObject = item
        store.dispatch('company/selectCompany', item.id)

        // On mobile, get the drawer out of the way after picking a company,
        // but keep it open when the tap was on the expand chevron (browsing).
        if (this.$vuetify.breakpoint.mobile) {
          const isToggle = e?.target?.closest?.('.v-treeview-node__toggle')
          if (!isToggle) {
            this.drawer = false
          }
        }
      },
      onOpenCompanyMenu ({ x, y }) {
        if (!this.currentObject || !this.currentObject.id) {
          return
        }

        this.showMenu = false
        this.x = x
        this.y = y
        this.$nextTick(() => {
          this.showMenu = true
        })
      },
      async openSelectedCompanyProvisioningQr () {
        const companyId = this.selectedCompanyId

        if (!companyId) {
          this.$toast.error('Select a company before opening Provisioning QR.', 'Error', {
            position: 'topRight',
          })
          return
        }

        let company = store.state.company.companies[companyId]

        if (!company) {
          try {
            await store.dispatch('company/loadCompanies', 0)
            company = store.state.company.companies[companyId]
          } catch (error) {
            this.showCompanyLoadError(error)
            return
          }
        }

        if (!company) {
          this.$toast.error('Could not load the selected company for Provisioning QR.', 'Error', {
            position: 'topRight',
          })
          return
        }

        this.currentObject = company
        this.provisioningQrDialog = true
      },
      openMenu (e, item) {
        e.preventDefault()

        this.currentObject = item
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },
      menuHandler (option) {
        if (['Licensee', 'Add', 'Delete'].includes(option) && !this.isSuperUser) {
          this.$toast.error('This action requires the SuperUser role.', 'Error', {
            position: 'topRight',
          })
          return
        }

        switch (option) {
          case 'Licensee':
            this.companyLicenseeDialog = true
            break
          case 'WiFi-QR':
            this.wifiDialog = true
            this.getWifiConfigByCompany(this.currentObject.id)
            break
          case 'Generate-QR':
            this.generateQRDialog = true
            break
          case 'Provisioning-QR':
            this.provisioningQrDialog = true
            break
          case '3rd Party-QR':
            this.wifiImageDialog = true
            break
          case 'Scripts':
            this.deviceConfigDialog = true
            break
          case 'Additional Info':
            this.openCompanyMetaEdit()
            break
          case 'Add':
            this.dialog = true
            break
          case 'Rename':
            this.editItem(this.currentObject)
            break
          case 'Delete':
            this.deleteItem(this.currentObject)
            break
          case 'Device-Files':
            this.deviceFilesDialog = true
            break
          default:
            break
        }
      },

      // Read any meta already stored on the company. It may arrive as a `meta`
      // object or a `metadata` JSON string depending on the API shape.
      parseCompanyMeta (company) {
        // The API may use camelCase or PascalCase, and send an object, a JSON string,
        // or the "Label: value, Label: value" summary.
        const fields = ['meta', 'Meta', 'metadata', 'metaData', 'Metadata', 'MetaData']

        for (const field of fields) {
          const raw = company?.[field]

          if (raw && typeof raw === 'object' && Object.keys(raw).length) {
            return raw
          }

          if (typeof raw !== 'string' || !raw.trim()) {
            continue
          }

          try {
            const parsed = JSON.parse(raw)
            if (parsed && typeof parsed === 'object' && Object.keys(parsed).length) {
              return parsed
            }
          } catch (error) {
            const summary = {}
            raw.split(',').forEach((pair) => {
              const separator = pair.indexOf(':')
              if (separator > 0) {
                summary[pair.slice(0, separator).trim()] = pair.slice(separator + 1).trim()
              }
            })
            if (Object.keys(summary).length) {
              return summary
            }
          }
        }

        return {}
      },
      getCompanySlug (company) {
        const entry = Object.entries(this.parseCompanyMeta(company))
          .find(([label]) => String(label || '').trim().toLowerCase() === 'slug')
        return entry ? String(entry[1] || '').trim().replace(/^\/+|\/+$/g, '') : ''
      },
      hasCompanyMeta (company) {
        return !!company?.metaLoaded || Object.keys(this.parseCompanyMeta(company)).length > 0
      },
      // The company list doesn't return meta for every user, so load it from Company/{id} when missing.
      async fetchCompanyMeta (company) {
        if (!company?.id || this.hasCompanyMeta(company)) {
          return company
        }

        try {
          const response = await this.$http.get(`Company/${encodeURIComponent(company.id)}`)
          const data = response?.data?.data || response?.data || {}

          this.$set(company, 'meta', this.parseCompanyMeta(data))
          this.$set(company, 'metaLoaded', true)
          if (!company.name && data.name) {
            this.$set(company, 'name', data.name)
            this.$set(company, 'image', data.image)
          }
        } catch (error) {
          // Keep whatever the company list returned.
        }

        return company
      },
      selectedCompanyStorageKey () {
        return `mydevices:selectedCompanyId:${store.state.authUser?.username || ''}`
      },
      rememberSelectedCompanyId (companyId) {
        try {
          if (companyId) {
            localStorage.setItem(this.selectedCompanyStorageKey(), String(companyId))
          }
        } catch (error) {
          // Storage unavailable; refresh falls back to the first company.
        }
      },
      getRememberedCompanyId () {
        try {
          return Number(localStorage.getItem(this.selectedCompanyStorageKey())) || 0
        } catch (error) {
          return 0
        }
      },
      async findCompanyByRouteSlug () {
        const routeSlug = String(this.$route.params.slug || '').trim().toLowerCase()
        if (!routeSlug) {
          return null
        }

        const matchesSlug = company => this.getCompanySlug(company).toLowerCase() === routeSlug
        const companies = store.state.company.companies
        const loaded = Object.values(companies)

        const found = loaded.find(matchesSlug)
        if (found) {
          return found
        }

        // Last selected company first: one request when a sub company page is refreshed.
        const rememberedId = this.getRememberedCompanyId()
        if (rememberedId) {
          const remembered = companies[rememberedId] || { id: rememberedId, children: [] }
          await this.fetchCompanyMeta(remembered)
          if (matchesSlug(remembered)) {
            store.commit('company/rememberCompany', remembered)
            return companies[remembered.id] || remembered
          }
        }

        // Otherwise walk the company tree level by level, as expanding it would, until the slug matches.
        const maxDepth = 6
        const maxLoadsPerLevel = 50
        const visited = new Set()
        let level = store.getters['company/getBaseCompanies']

        for (let depth = 0; depth < maxDepth && level.length; depth++) {
          await Promise.all(level.map(company => this.fetchCompanyMeta(company)))

          const match = level.find(matchesSlug)
          if (match) {
            return match
          }

          const parents = level.filter(company => !visited.has(company.id)).slice(0, maxLoadsPerLevel)
          parents.forEach(company => visited.add(company.id))

          const children = await Promise.all(
            parents.map(company => store.dispatch('company/loadCompanies', company.id).catch(() => [])),
          )
          level = children.flat()
        }

        return null
      },
      // Keep the Devices address as /<slug>/devices for the selected company (or /devices without one).
      async syncCompanySlugRoute () {
        if (!this.companySlugRouteReady || this.$route.name !== 'Devices') {
          return
        }

        const companyId = this.selectedCompanyId
        const company = store.state.company.companies[companyId]
        if (company) {
          await this.fetchCompanyMeta(company)
        }

        // Another company was picked (or the page changed) while meta was loading.
        if (companyId !== this.selectedCompanyId || this.$route.name !== 'Devices') {
          return
        }

        const slug = company ? this.getCompanySlug(company) : ''

        if ((this.$route.params.slug || '') === slug) {
          return
        }

        this.$router.replace({
          name: 'Devices',
          params: { slug: slug || undefined },
          query: this.$route.query,
        }).catch(() => {})
      },
      buildCompanyMetaRows (company) {
        const existing = this.parseCompanyMeta(company)
        const entries = Object.entries(existing)

        // Sensible starting point when the company has no stored info yet.
        const rows = entries.length
          ? entries.map(([label, value]) => ({
            label: String(label || ''),
            value: value == null ? '' : String(value),
          }))
          : [
            { label: 'Network Code', value: '' },
            { label: 'Address', value: '' },
          ]

        // Draft rows: offered until the label is stored; only saved once they have a value.
        const draftRows = [
          { label: 'Domain URL', placeholder: 'e.g. https://example.com' },
          { label: 'Slug', placeholder: 'e.g. rebel' },
        ]
        draftRows.forEach(({ label, placeholder }) => {
          if (!rows.some(row => row.label.trim().toLowerCase() === label.toLowerCase())) {
            rows.push({ label, value: '', draft: true, placeholder })
          }
        })

        return rows
      },
      async openCompanyMetaEdit () {
        if (!this.currentObject || !this.currentObject.id) {
          this.$toast.error('Select a company first.', 'Error', { position: 'topRight' })
          return
        }

        this.companyMetaError = ''
        await this.fetchCompanyMeta(this.currentObject)
        this.companyMetaRows = this.buildCompanyMetaRows(this.currentObject)
        this.companyMetaDialog = true
      },
      addCompanyMetaRow () {
        this.companyMetaRows.push({ label: '', value: '' })
      },
      removeCompanyMetaRow (index) {
        this.companyMetaRows.splice(index, 1)
      },
      async saveCompanyMetaEdit () {
        const company = this.currentObject
        const companyId = company?.id

        if (!company || !companyId) {
          this.companyMetaError = 'This company cannot be updated (missing id).'
          return
        }

        const meta = {}
        const seenLabels = new Set()

        for (const row of this.companyMetaRows) {
          const label = String(row.label || '').trim()

          // Rows without a value are not stored.
          if (!label || !String(row.value == null ? '' : row.value).trim()) {
            continue
          }

          const labelKey = label.toLowerCase()
          if (seenLabels.has(labelKey)) {
            this.companyMetaError = `Duplicate label "${label}". Each label must be unique.`
            return
          }
          seenLabels.add(labelKey)

          meta[label] = String(row.value == null ? '' : row.value)
        }

        this.companyMetaSaving = true
        this.companyMetaError = ''

        try {
          const response = await this.$http.put('Company/UpdateMeta', {
            id: companyId,
            meta,
          })

          if (response?.data?.success === false) {
            this.companyMetaError = response.data.message || 'Could not save additional info.'
            return
          }

          // Reflect the saved values locally so re-opening the editor shows them.
          this.$set(company, 'meta', meta)
          this.$set(company, 'metaLoaded', true)
          this.$set(company, 'metadata', this.formatCompanyMetaSummary(meta))
          if (companyId === this.selectedCompanyId) {
            this.syncCompanySlugRoute()
          }

          this.$toast.success('Company additional info saved.', 'Success', { position: 'topRight' })
          this.companyMetaDialog = false
        } catch (error) {
          this.companyMetaError =
            error?.response?.data?.message ||
            error?.message ||
            'Could not save additional info.'
          this.$toast.error(this.companyMetaError, 'Error', { position: 'topRight' })
        } finally {
          this.companyMetaSaving = false
        }
      },
      formatCompanyMetaSummary (meta) {
        return Object.entries(meta)
          .map(([label, value]) => `${label}: ${value}`)
          .join(', ')
      },

      async fetchChildren (item) {
        this.openedCompanyId = item.id
        try {
          await store.dispatch('company/loadCompanies', item.id)
        } catch (error) {
          this.showCompanyLoadError(error)
        }
      },

      showCompanyLoadError (error) {
        this.$toast.error(
          error?.response?.data?.message || error?.response?.data?.error || 'Could not load companies.',
          'Error',
          {
            position: 'topRight',
          },
        )
      },

      getWifiConfigByCompany (id) {
        this.$http
          .get('WifiConfig/GetWifiConfigByCompany', { params: { companyId: id } })
          .then((response) => {
            if (response.data != null && typeof response.data === 'object') {
              this.wifiItem = Object.assign({}, response.data)
            }
          })
      },

      editItem (item) {
        this.editedIndex = item.id
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = item.id
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.$http
          .delete('Company/Delete', { params: { id: this.editedItem.id } })
          .then((response) => {
            if (response.data.success) {
              // this.items.splice(index, 1);
              this.$toast.success(response.data.message, 'Success', {
                position: 'topRight',
              })
            } else {
              this.$toast.success(response.data.message, 'Success', {
                position: 'topRight',
              })
            }
          })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeWifi () {
        this.wifiDialog = false
        this.$nextTick(() => {
          this.wifiItem = Object.assign({}, this.defaultWifi)
          this.wifiEditedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          const data = new FormData()
          data.append('name', this.editedItem.name)
          data.append('image', this.editedItem.image)
          data.append('id', this.editedItem.id)
          this.$http.put('Company/Update', data).then((response) => {
            if (response.data.success) {
              // Object.assign(this.items[index], response.data.data);
              this.$toast.success(response.data.message, 'Success', {
                position: 'topRight',
              })
            } else {
              this.$toast.error(response.data.message, 'Error', {
                position: 'topRight',
              })
            }
          })
        } else {
          const data = new FormData()
          data.append('name', this.editedItem.name)
          data.append('image', this.editedItem.image)
          const companyId = this.currentObject.id
          if (companyId > 0) {
            data.append('companyId', companyId)
          }
          this.$http.post('Company/Create', data).then((response) => {
            if (response.data.success) {
              const result = response.data.data
              if (!result.hasOwnProperty('children')) {
                result.children = []
              }
              this.currentObject.children.push(result)
              this.$toast.success(response.data.message, 'Success', {
                position: 'topRight',
              })
            } else {
              this.$toast.success(response.data.message, 'Success', {
                position: 'topRight',
              })
            }
          })
        }
        this.close()
      },
      saveWifi () {
        if (this.wifiItem.id > 0) {
          this.$http
            .put(`WifiConfig/update/${this.wifiItem.id}`, {
              active: this.wifiItem.active,
              essid: this.wifiItem.essid,
              password: this.wifiItem.password,
              encryption: this.wifiItem.encryption,
            })
            .then((response) => {
              if (response.data.success) {
                this.$toast.success(response.data.message, 'Success', {
                  position: 'topRight',
                })
              } else {
                this.$toast.error(response.data.message, 'Error', {
                  position: 'topRight',
                })
              }
            })
        } else {
          this.$http
            .post('WifiConfig/CreateWifiConfig', {
              referenceId: this.currentObject.id,
              active: this.wifiItem.active,
              essid: this.wifiItem.essid,
              password: this.wifiItem.password,
              encryption: this.wifiItem.encryption,
              type: 1,
            })
            .then((response) => {
              if (response.data.success) {
                this.$toast.success(response.data.message, 'Success', {
                  position: 'topRight',
                })
              } else {
                this.$toast.error(response.data.message, 'Error', {
                  position: 'topRight',
                })
              }
            })
        }

        this.closeWifi()
      },
      onUpdateCompany (company) {
        this.currentObject.code = company.code
        this.currentObject.maxLicense = company.maxLicense
      },
      onExpand () {
        this.$nextTick(() => {
          const nodes = this.$refs.treeview.nodes

          for (const [key, value] of Object.entries(nodes)) {
            const element = value.vnode?.$el
            if (element && !element.id) {
              element.id = `drawer:company:${key}`

              const rootElement = element.firstElementChild
              if (rootElement) {
                rootElement.addEventListener('contextmenu', (e) => this.openMenu(e, value.item), true)
                rootElement.addEventListener('click', (e) => setTimeout(() => {
                  const item = value.item
                  this.onClick(item, e)
                }, 0), true)

                // Touch long-press mirrors right-click: open the options menu.
                const startPress = (e) => {
                  const touch = e.touches ? e.touches[0] : e
                  clearTimeout(this.pressTimer)
                  this.pressTimer = setTimeout(() => {
                    // Suppress the synthetic click(s) that follow the long-press.
                    this.suppressUntil = Date.now() + 800
                    this.openMenu({ preventDefault: () => {}, clientX: touch.clientX, clientY: touch.clientY }, value.item)
                  }, 500)
                }
                const cancelPress = () => clearTimeout(this.pressTimer)
                rootElement.addEventListener('touchstart', startPress, { passive: true })
                rootElement.addEventListener('touchmove', cancelPress, { passive: true })
                rootElement.addEventListener('touchend', cancelPress)
                rootElement.addEventListener('touchcancel', cancelPress)
              }
            }
          }
        })
      },

      expandItem (companyId) {
        const element = document.getElementById(`drawer:company:${companyId}`)
        if (!element) {
          return
        }

        const isExpanded = element.getAttribute('aria-expanded') === 'true'

        if (isExpanded) {
          return
        }

      element?.firstElementChild?.click?.()
      },
    },
  }
</script>

<style scoped>
  .company-meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }

  .company-meta-row__label {
    flex: 0 0 38%;
  }

  .company-meta-row__value {
    flex: 1 1 auto;
  }

  .company-meta-row__remove {
    flex: 0 0 auto;
  }

  @media (max-width: 599px) {
    .company-meta-row {
      flex-wrap: wrap;
    }

    .company-meta-row__label,
    .company-meta-row__value {
      flex: 1 1 100%;
    }
  }
</style>
